<template>
  <div
    class="floating-box"
    :style="boxStyle"
    @mouseenter="pauseFloating"
    @mouseleave="resumeFloating"
    ref="floatingBox"
  >
    <div class="floating-body">
      <div class="close-btn" @click="closeBox">×</div>
      <div class="content">咨询热线 </div>
      <div class="content02">
        {{ siteInfo.hotline }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "FloatingBox",
  data() {
    return {
      posX: 0,
      posY: 0,
      velX: 0,
      velY: 0,
      isPaused: false,
      isClosed: false,
      animationFrameId: null,
    };
  },
  computed: {
    ...mapGetters(["siteInfo"]),
    boxStyle() {
      return {
        left: `${this.posX}px`,
        top: `${this.posY}px`,
        display: this.isClosed ? "none" : "block",
      };
    },
  },
  mounted() {
    this.initPosition();
    this.initVelocity();
    this.startFloating();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationFrameId);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    initPosition() {
      const boxWidth = this.$refs.floatingBox.offsetWidth;
      const boxHeight = this.$refs.floatingBox.offsetHeight;
      this.posX = Math.random() * (window.innerWidth - boxWidth);
      this.posY = Math.random() * (window.innerHeight - boxHeight);
    },
    initVelocity() {
      // 初始速度 (随机方向，速度适中)
      this.velX = (Math.random() - 0.5) * 5.5;
      this.velY = (Math.random() - 0.3) * 5.5;
    },
    startFloating() {
      const animate = () => {
        if (!this.isPaused && !this.isClosed) {
          this.updatePosition();
        }
        this.animationFrameId = requestAnimationFrame(animate);
      };
      animate();
    },
    updatePosition() {
      const boxWidth = this.$refs.floatingBox.offsetWidth;
      const boxHeight = this.$refs.floatingBox.offsetHeight;

      // 更新位置
      this.posX += this.velX;
      this.posY += this.velY;

      // 边界检测和反弹
      if (this.posX <= 0 || this.posX >= window.innerWidth - boxWidth) {
        this.velX = -this.velX * 0.9; // 反弹并减速
        this.posX = Math.max(
          0,
          Math.min(this.posX, window.innerWidth - boxWidth)
        );
      }

      if (this.posY <= 0 || this.posY >= window.innerHeight - boxHeight) {
        this.velY = -this.velY * 0.9; // 反弹并减速
        this.posY = Math.max(
          0,
          Math.min(this.posY, window.innerHeight - boxHeight)
        );
      }
    },
    pauseFloating() {
      this.isPaused = true;
    },
    resumeFloating() {
      this.isPaused = false;
    },
    closeBox() {
      this.isClosed = true;
    },
    handleResize() {
      // 窗口大小变化时调整位置，避免超出边界
      const boxWidth = this.$refs.floatingBox.offsetWidth;
      const boxHeight = this.$refs.floatingBox.offsetHeight;

      this.posX = Math.min(this.posX, window.innerWidth - boxWidth);
      this.posY = Math.min(this.posY, window.innerHeight - boxHeight);
    },
  },
};
</script>

<style scoped>
.floating-box {
  position: fixed;
  width: 200px;
  height: 120px;
  /* 移除原背景图设置 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  z-index: 1000;
  transition: transform 0.3s ease;
  /* 确保内容层级高于伪元素 */
  overflow: hidden; /* 防止圆角失效 */
}

/* 添加伪元素作为半透明背景层 */
.floating-body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("../../assets/images/hots.jpg") no-repeat center center;
  background-size: cover;
  opacity: 0.5;
  z-index: -1;
  border-radius: 5px;
}

.floating-box::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: -1;
  border-radius: 5px;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  background: #ff4444;
  color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
  z-index: 1001;
}

.content {
  padding: 34px 0 0 0px;
  user-select: none;
  font-weight: bold;
  color: #8a4d4d;
  font-size: 19px;
  text-align: center;
}
.content02 {
  padding: 7px 0 0 0px;
  user-select: none;
  font-weight: bold;
  color: #8a4d4d;
  font-size: 19px;
  text-align: center;
}
</style>